// Phase 25 iter-5e — Stripe Connect onboarding client.
//
// Backend (backend/src/routes/v1/payments-connect.ts):
//   POST /api/v1/payments/connect/onboard → { onboarding_url }
//   GET  /api/v1/payments/connect/status  → ConnectStatusResponse

import {
  API_VERSION_PREFIX,
  type ConnectOnboardResponse,
  type ConnectStatusResponse,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function getConnectStatus(): Promise<ConnectStatusResponse> {
  const { data } = await apiClient.get<ConnectStatusResponse>(
    `${API_VERSION_PREFIX}/payments/connect/status`,
  );
  return data;
}

export async function startConnectOnboarding(): Promise<ConnectOnboardResponse> {
  const { data } = await apiClient.post<ConnectOnboardResponse>(
    `${API_VERSION_PREFIX}/payments/connect/onboard`,
  );
  return data;
}
